export default __webpack_public_path__ + "static/media/Mobile login-cuate.f7869b38.svg";